import styled from "styled-components";

export const Wrapper = styled.form`
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  max-height: 85vh;
  overflow: hidden;
`;

export const Header = styled.div`
  flex-shrink: 0;
  position: relative;
  padding: 20px;
  background: #323232;
`;

export const CloseButton = styled.button`
  display: flex;
  color: #ffffff;
  background: transparent;
  border: none;
  border-radius: 0.8rem;
  padding: 4px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  svg {
    width: 2.4rem;
    height: 2.4rem;
  }
  &:hover {
    background: rgba(255, 255, 255, 0.3);
  }
`;

export const HeaderContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  .title {
    display: flex;
    align-items: center;
    gap: 8px;
  }
`;

export const HeaderIcon = styled.div`
  width: 40px;
  height: 40px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 1.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  svg {
    width: 24px;
    height: 24px;
    color: #ffffff;
  }
`;

export const HeaderTitle = styled.h2`
  color: #ffffff;
  font-size: 14px;
  font-weight: 500;
  margin: 0 !important;
`;

export const HeaderSubtitle = styled.p`
  color: rgba(255, 255, 255, 0.9);
  margin: 2px 0 0 0;
  font-size: 12px;
`;

export const Body = styled.div`
  overflow-y: auto;
  min-height: 0;
  padding: 20px;
`;

export const Section = styled.div`
  margin-bottom: 20px;
`;

export const SectionTitleWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 0.8rem;
  margin-bottom: 20px;
`;

export const SectionMarker = styled.div`
  width: 0.4rem;
  height: 1.8rem;
  background-color: #30a690;
  border-radius: 1.2rem;
`;

export const SectionTitle = styled.h3`
  margin: 0;
  font-size: 1.4rem;
  color: #101828;
`;

export const SectionNote = styled.span`
  font-size: 1.2rem;
  color: #4a5565;
`;

export const GridTwoCols = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
  @media (max-width: 560px) {
    grid-template-columns: 1fr;
  }
`;

export const InputGroup = styled.div<{ full?: boolean }>`
  grid-column: ${(p) => (p.full ? "span 2" : "auto")};
`;

export const Label = styled.label`
  display: block;
  color: #4a5565;
  margin-left: 8px;
  margin-bottom: 4px;
  font-size: 14px;
`;

export const Required = styled.span`
  color: #ef4444;
`;

export const InputWrapper = styled.div`
  position: relative;
`;

export const IconLeft = styled.div`
  position: absolute;
  left: 1.2rem;
  top: 50%;
  transform: translateY(-50%);
  color: #99a1af;
  display: flex;
  svg {
    width: 2rem;
    height: 2rem;
  }
`;

export const Input = styled.input`
  width: 100%;
  padding: 1.2rem 1.2rem 1.2rem 3.6rem;
  border: 1px solid #e5e7eb;
  border-radius: 0.8rem;
  font-size: 13px;
  color: #111827;
  transition:
    border-color 0.2s ease,
    box-shadow 0.2s ease;
  &[readonly] {
    background: #f3f4f6;
    color: #6b7280;
  }
  &:focus {
    outline: none;
    border-color: transparent;
    box-shadow: 0 0 0 2px rgba(48, 166, 144, 0.4);
  }
`;

export const Notice = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  border-radius: 0.8rem;
  padding: 14px 16px 16px;
`;

export const NoticeIcon = styled.svg`
  width: 2rem;
  height: 2rem;
  color: #2563eb;
  flex-shrink: 0;
`;

export const NoticeTitle = styled.p`
  margin: 2px 0 4px 0;
  font-weight: 400;
  font-size: 1.4rem;
  color: #1d4ed8;
`;

export const NoticeText = styled.p`
  margin: 0;
  font-size: 1.3rem;
  color: #1d4ed8;
`;

export const Footer = styled.div`
  flex-shrink: 0;
  display: flex;
  justify-content: flex-end;
  gap: 1.2rem;
  padding: 20px;
  background: #f9fafb;
  border-top: 1px solid #e5e7eb;
  border-radius: 0 0 1.6rem 1.6rem;
`;

export const BaseButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  border-radius: 0.6rem;
  font-size: 14px;
  width: 100px;
  height: 35px;

  cursor: pointer;
  border: none;
  transition: all 0.2s ease;
  svg {
    width: 2rem;
    height: 2rem;
  }
`;

export const CancelButton = styled(BaseButton)`
  background: #ffffff;
  border: 1px solid #2d2d2d;
  color: #2d2d2d;
  &:hover {
    border-color: #ff4a48;
  }
`;

export const SubmitButton = styled(BaseButton)<{ disabled?: boolean }>`
  background: ${(p) => (p.disabled ? "#d1d5db" : "#4abbcc")};
  color: ${(p) => (p.disabled ? "#6b7280" : "#ffffff")};
  cursor: ${(p) => (p.disabled ? "not-allowed" : "pointer")};
  &:hover {
    background: ${(p) => (p.disabled ? "#d1d5db" : "#2c94a4")};
  }
`;

export const ErrorText = styled.p`
  margin: 0.6rem 0 0 0;
  font-size: 1.3rem;
  color: #ef4444;
`;

export const RadioGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 2rem;
  min-height: 40px;
  padding-left: 10px;
  label {
    display: inline-flex;
    align-items: center;
    gap: 0.6rem;
    font-size: 1.4rem;
    color: #4a5565;
  }
  input {
    accent-color: #1e88d9;
    margin: 0;
  }
`;
